import { createFileRoute, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const getCoachOfferRedirect = createServerFn({ method: "GET" })
  .validator(z.object({ username: z.string() }))
  .handler(async ({ data }) => {
    const { getCoachByUsername } = await import("~/lib/server/coach");
    const { getDBWithInit } = await import("~/lib/db");

    const coach = await getCoachByUsername(data.username);

    if (!coach) {
      return { offerId: null, coachExists: false };
    }

    // First priority: use the coach's main offer if set
    if (coach.mainOfferId) {
      return { offerId: coach.mainOfferId, coachExists: true };
    }

    // Second priority: find the first available offer for this coach
    const firstOffer = await (
      await getDBWithInit()
    ).query.offers.findFirst({
      where: (offers, { eq }) => eq(offers.coachId, coach.id),
      columns: { id: true },
      orderBy: (offers, { asc }) => asc(offers.id),
    });

    return {
      offerId: firstOffer?.id || null,
      coachExists: true,
    };
  });

export const Route = createFileRoute("/$username/_profile/offer/")({
  beforeLoad: async ({ params }) => {
    const username = params.username;
    const result = await getCoachOfferRedirect({ data: { username } });

    // If coach doesn't exist, redirect to 404 or homepage
    if (!result.coachExists) {
      throw redirect({ to: "/$username", params: { username } });
    }

    // If no offers available, redirect back to coach profile
    if (!result.offerId) {
      throw redirect({ to: "/$username", params: { username } });
    }

    // Redirect to the specific offer
    throw redirect({
      to: "/$username/offer/$offerId",
      params: { username, offerId: result.offerId },
    });
  },
});
